module.exports = __webpack_public_path__ + "static/CormorantSC-Bold-fe95155092c260e8c84c0c8b965445b4.ttf";